// Miky Motorsport - cista matematika kamery (FOV dle rychlosti, frame-rate
// nezavisly damping). Bez THREE - ciste aritmeticke funkce, testovatelne v Node.
// camera.js je importuje a vola, aby chovani kamery zustalo identicke.

// Cilove FOV dle rychlosti: linearni interpolace base -> max pres podil rychlosti
// vuci speedKmhAtMax (orezany na 1). Pri 0 km/h = base, pri >= speedKmhAtMax = max.
// speedKmh se predpoklada >= 0 (volajici pouziva Math.abs(speedMs)*MS_TO_KMH).
export function targetFovFor(speedKmh, base, max, speedKmhAtMax) {
  const frac = Math.min(speedKmh / speedKmhAtMax, 1);
  return base + (max - base) * frac;
}

// Frame-rate nezavisly damping faktor pro exponencialni lerp: 1 - exp(-stiff*dt).
// dt=0 -> 0 (zadny pohyb), velke dt -> ~1 (skoro dorovna). Pro bezne dt v (0,1).
// Vyssi stiffness -> vyssi faktor (tuzsi sledovani). stiff,dt >= 0.
export function dampFactor(stiffness, dt) {
  return 1 - Math.exp(-stiffness * dt);
}

function clamp(v, lo, hi) { return v < lo ? lo : v > hi ? hi : v; }

// Naklon (roll) kamery do zatacky podle rizeni a rychlosti. steer v -1..1 (+ = vpravo).
// Vic naklonu pri vyssi rychlosti (do refKmh), nikdy vic nez maxRad. Vraci radiany.
// Nulovy pri rovne (steer 0) nebo stani (speed 0). Znamenko ladi vizualne camera.js.
export function cameraRoll(steer, speedKmh, maxRad, refKmh) {
  const s = clamp(steer, -1, 1);
  const spd = refKmh > 0 ? clamp(speedKmh / refKmh, 0, 1) : 0;
  return -s * spd * maxRad + 0; // + 0 normalizuje -0 na +0
}

// Bocni posun look-at bodu do zatacky (kamera "kouka do" zatacky). steer -1..1.
// Skaluje s rychlosti (do refKmh) a velikosti rizeni; aplikuje se podel prave osy auta.
export function lookAheadLateral(steer, speedKmh, maxLateral, refKmh) {
  const s = clamp(steer, -1, 1);
  const spd = refKmh > 0 ? clamp(speedKmh / refKmh, 0, 1) : 0;
  return s * spd * maxLateral + 0; // + 0 normalizuje -0 na +0
}

// A4: ma se spustit near-miss efekt? Auto je blizko (dist < threshold) a hrac jede dost
// rychle (>= minKmh). Cista rozhodovaci funkce (debounce/cooldown resi volajici).
export function shouldNearMiss(dist, threshold, playerKmh, minKmh) {
  return dist < threshold && Math.abs(playerKmh) >= minKmh;
}
